/**
 * Created by thakuva on 6/4/2017.
 * @module EllipsesControl
 * @extends React.Component
 */

import React, {memo} from 'react';
import Ellipse from '@ey/canvascoreservices/Ellipse';

/**
 * Memoized EllipsesControl - skips re-render when props are equal.
 * Performance optimization for lists with many text truncation elements.
 */
const EllipsesControl = memo(function EllipsesControl(props) {
	return <Ellipse {...props} />;
});

export default EllipsesControl;
